var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import { gql, useQuery } from "@apollo/client";
import { keyBy } from "lodash";
export var useEntityTypeDefinitionsQuery = function (entityTypeNames) {
  if (entityTypeNames === void 0) {
    entityTypeNames = [];
  }
  var _a = useQuery(gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      query EntityTypeDefinitionsQuery($entityTypeNames: [String]) {\n        entityTypeDefinitions(entityTypeNames: $entityTypeNames) {\n          oneName\n          name\n          label\n          pluralLabel\n          createLabel\n          createAnotherLabel\n          deleteLabel\n          formFields {\n            label\n            description\n            ownDescription\n            name\n            type\n            formFieldType\n            required\n            entityTypeName\n            entityTypeNamePlural\n          }\n        }\n      }\n    "], ["\n      query EntityTypeDefinitionsQuery($entityTypeNames: [String]) {\n        entityTypeDefinitions(entityTypeNames: $entityTypeNames) {\n          oneName\n          name\n          label\n          pluralLabel\n          createLabel\n          createAnotherLabel\n          deleteLabel\n          formFields {\n            label\n            description\n            ownDescription\n            name\n            type\n            formFieldType\n            required\n            entityTypeName\n            entityTypeNamePlural\n          }\n        }\n      }\n    "]))), {
      variables: {
        entityTypeNames: entityTypeNames
      }
    }),
    data = _a.data,
    loading = _a.loading,
    error = _a.error;
  var entityTypeDefinitions = (data === null || data === void 0 ? void 0 : data.entityTypeDefinitions) || [];
  return {
    loading: loading,
    entityTypeDefinitions: keyBy(entityTypeDefinitions, 'name') || {},
    error: error
  };
};
var templateObject_1;